import PropTypes from "prop-types";
import clsx from "clsx";
import Swiper, { SwiperSlide } from "../components/swiper";
import icon1 from "../assets/images/Icon/home_card_icon_1.png";
import icon2 from "../assets/images/Icon/home_card_icon_2.png";
import icon3 from "../assets/images/Icon/home_card_icon_3.png";
import icon4 from "../assets/images/Icon/home_card_icon_4.png";

const data = [
  {
    id: "1",
    image: icon1,
    subtitle: "30 KG",
    title: "PRODUCTION CAPACITY",
  },
  {
    id: "2",
    image: icon2,
    subtitle: "250+",
    title: "MONTHLY DESIGNS",
  },
  {
    id: "3",
    image: icon3,
    subtitle: "100K+",
    title: "JEWELRY MADE",
  },
  {
    id: "4",
    image: icon4,
    subtitle: "500+",
    title: "SKILLED MANPOWER",
  },
];

// swiper slider setting
const settings = {
  loop: false,
  spaceBetween: 20,
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
};

const CategoryOneSlider = ({ spaceBottomClass }) => {
  return (
    <section
      className={clsx("collections-area home_hero_cards", spaceBottomClass)}
    >
      <div className="container">
        {data && (
          <Swiper options={settings}>
            {data.map((single, key) => (
              <SwiperSlide key={key}>
                <div className="collection-product-2">
                  <div className="collection-content-2 text-center">
                    <img src={single.image} alt={single.subtitle} />
                    <h4>{single.subtitle}</h4>
                    <span>{single.title}</span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
};

CategoryOneSlider.propTypes = {
  spaceBottomClass: PropTypes.string,
};

export default CategoryOneSlider;
